<template>
  <div class="keypad">
    <!-- <Button
      v-if="state$$.stateId === 1"
      class="p-button-secondary"
      label="Descargar PDF"
      icon="pi pi-download"
      @click="downloadPDF"
    /> -->
    <Button
      class="p-button-secondary"
      label="Editar datos de contacto"
      icon="pi pi-user-edit"
      tabindex="0"
      @click="editDataContact"
      @keyup.enter="editDataContact"
    />
    <Button
      v-tooltip.right="{
        value: 'Aún no puedes reenviar al notificación',
        class: blockSendBtn ? '': 'custom-error-tooltip'
      }"
      class="p-button-secondary"
      label="Reenviar notificación"
      icon="pi pi-send"
      :disabled="blockSendBtn"
      tabindex="0"
      @click="sendMail"
      @keyup.enter="sendMail"
    />
  </div>
</template>

<script setup>
// #region VUE
import {
  inject,
  ref,
} from 'vue';
// #endregion

// #region COMPONENTS COMPOSABLES
import {
  useDev,
  // useDownload,
} from '@sttedra_ui/framework';

import Button from 'primevue/button/sfc';
import useManageApiError from '@/composables/manage-api-error';
import {useRouter} from 'vue-router';
import {useDebounceFn} from '@vueuse/core';
// #endregion

// #region API
import {StatusCodes as HttpStatus} from 'http-status-codes';
import {
  // generateMitmaCodePdf as generateMitmaCodePdfApi,
  sendMailInfo as sendMailInfoApi,
} from '@/api/register/register.api';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const state$$ = inject('detailRequestState$$');
const {showErrorToast, showSuccessToast} = useManageApiError();
const router = useRouter();
const blockSendBtn = ref(false);
// #endregion

// #region Functions
const sendMail = useDebounceFn(sendMailFn, 200, {maxWait: 700});
async function sendMailFn() {
  try {
    const {
      identification,
      temporalToken,
    } = state$$.detailModel;

    const {response, data} = await sendMailInfoApi(identification, temporalToken);

    if (response.status === HttpStatus.OK) {
      showSuccessToast('El correo ha sido enviado con éxito.');
      blockSendBtn.value = true;

      setTimeout(() => {
        blockSendBtn.value = false;
      }, 7000);
      return;
    }

    if (!data) {
      // eslint-disable-next-line max-len
      showErrorToast('Ha ocurrido un error al enviar el correo. Por favor, inténtelo de nuevo más tarde.');
      blockSendBtn.value = false;
      return;
    }
  } catch (error) {
    useDev.error('[DetailRequestKeypad] sendMail', error);
  }
}

const editDataContact = useDebounceFn(editDataContactFn, 200, {maxWait: 700});
function editDataContactFn() {
  router.push({name: 'EditRegisterContact'});
}

// const downloadPDF = useDebounceFn(downloadPDFFn, 200, {maxWait: 700});
// async function downloadPDFFn() {
//   try {
//     const {
//       identification,
//     } = state$$.detailModel;
//     useDownload(() => generateMitmaCodePdf(), [{}],
//       `código_descuento_mitma_${identification}.pdf`);
//   } catch (error) {
//     useDev.error('[DetailRequestKeypad] downloadPDF', error);
//   }
// }

// async function generateMitmaCodePdf() {
//   try {
//     const {
//       mitmaCode,
//       identification,
//     } = state$$.detailModel;

//     const {response, data} = await generateMitmaCodePdfApi({
//       mitmaCode,
//       identification,
//     });

//     if (response.status === HttpStatus.OK) {
//       return response;
//     }

//     if (!data) {
//       showErrorToast('No se ha podido generar el PDF');
//       return;
//     }
//   } catch (error) {
//     useDev.error('[DetailRequestKeypad] downloadPDF', error);
//   }
//   return null;
// }
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.keypad{
  align-items: center;
  display: flex;
  gap: $brand__boxspace--medium;
  justify-content: center;
  margin-top: $brand__boxspace--medium * 3;

  @include media("<=phone") {
    flex-direction: column;
  }
  @include media(">phone") {
    flex-direction: row;
  }

  & button{
    width: fit-content;
  }
}
</style>


<style lang="scss">
.custom-error-tooltip{
  display: none !important;
}
</style>
